// GameStateContext.js
import React from 'react';

const GameStateContext = React.createContext();

export default GameStateContext;